import { trpc, TrpcInputs, TrpcOutputs } from '../../config/trpc';

type UseVerifyAccount = [(args: VerifyAccountInput) => Promise<VerifyAccountOutput>, boolean, string];

export type VerifyAccountInput = TrpcInputs['verifyAccount'];
export type VerifyAccountOutput = TrpcOutputs['verifyAccount'];

export const useVerifyAccount = (): UseVerifyAccount => {
  const { mutateAsync, isLoading, error } = trpc.verifyAccount.useMutation();

  return [mutateAsync, isLoading, error?.message || ''];
};
